import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import { DefaultDraftBlockRenderMap } from 'draft-js';
import { Map } from 'immutable';
import { BlockType } from '@uno/common-cms';
var blockRenderMap = Map(_defineProperty({}, BlockType.UNSTYLED, {
  element: 'div'
}));
var extendedBlockRenderMap = DefaultDraftBlockRenderMap.merge(blockRenderMap);
export default extendedBlockRenderMap;